export const _NumberCardClassName = "relative max-h-[200px] overflow-hidden"
export const _ChartCardClassName = "relative max-h-[500px] overflow-hidden"
